import { Col, Divider, Form,  message, Modal, Row, Select, Space, theme, Tooltip } from "antd";
import _ from "lodash";
import React from "react";
import ErrorMessages from "../../common/ErrorMessages";
import { PRODUCT_TYPE } from "../../constants/string";
import { URL_SALE } from "../../constants/urls";
import { PATCH } from "../../frameworks/HttpClient";
import { ExclamationCircleOutlined, LinkOutlined } from "@ant-design/icons";
import ColorButton from "../../common/ColorButton";
import { dateToHumanString, formatComma } from "../../frameworks/Util";
import TSTable from "../../common/TSTable";

export default function ProduceRefSaleOrderModal(props) {
  const { open, onClose, onUpdate, target, type} = props;
  const tableRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [filterSameProduct, setFilterSameProduct] = React.useState(true)
  const [tableKey, setTableKey] = React.useState(0);
  const [form] = Form.useForm();

  const {
    token: { colorSuccess, colorPrimary },
  } = theme.useToken();

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleOK = async(id) => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const data = await form.validateFields();
      if(type === PRODUCT_TYPE.CONCENTRATE_LATEX){
        await PATCH(`${URL_SALE.PRODUCE_ORDER}${target.id}/`, {sale_order : id})
        message.success("เพิ่มใบแจ้งผลิตในรายการขายเรียบร้อยแล้ว")
        onUpdate();
      } else if (type === PRODUCT_TYPE.SKIM) {
        await PATCH(`${URL_SALE.SKIM_PRODUCE_ORDER}${target.id}/`, {sale_order : id})
        message.success("เพิ่มใบแจ้งผลิตในรายการขายเรียบร้อยแล้ว")
        onUpdate();
      }
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false);
    }
  }

  const confirmRefSaleOrder = (title, value) => {
    Modal.confirm({
      title: `ผูกใบแจ้งผลิต - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorPrimary }}/>,
      content: `คุณต้องการผูกใบแจ้งผลิตกับรายการขาย ${title} ใช่หรือไม่ `,
      okText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorPrimary}},
      onOk:async() => {
        await handleOK(value)
        refreshData();
      },
      onConfirm: () => refreshData()
    });
  };

  const columns = [
    {
      title: 'Action',
      dataIndex: 'id',
      width: 80,
      key: 'Action',
      render: (value, original) => {
        const isSameSaleOrder = value == _.get(target, 'sale_order', null)
        return (
          <div style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
            <Tooltip triger='hover' title={isSameSaleOrder ? "กำลังผูกกับรายการนี้อยู่" : "ผูกรายการขาย"}>
              <ColorButton
                override={colorSuccess}
                style={{ margin: 5 }}
                type='primary'
                disabled={isSameSaleOrder}
                icon={<LinkOutlined />}
                onClick={() => confirmRefSaleOrder(_.get(original, 'order_no', ''), value)} 
              />
            </Tooltip>
          </div>
        )
      }
    },
    {
      title: 'วันที่',
      dataIndex: 'order_date',
      key: 'order_date',
      render: (value) => dateToHumanString(value),
    },
    {
      title: 'Contract No.',
      dataIndex: 'order_no',
      key: 'order_no',
      searcher : true,
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'buyer_name',
      key: 'buyer_name',
      searcher : true,  
    },
    {
      title: 'สินค้าที่ต้องการ',
      dataIndex: 'product_name',
      key: 'product_name',
    },
    {
      title: 'Shipment',
      dataIndex: 'shipment',
      key: 'shipment',
    },
    {
      title: 'ปริมาณสั่งซื้อ (ก้อน)',
      dataIndex: 'require_amount',
      key: 'require_amount',
      render: (value) => <center>{formatComma(value)}</center>,
      hidden: type === PRODUCT_TYPE.CONCENTRATE_LATEX ? true : false
    },
    {
      title: 'ปริมาณสั่งซื้อ (kg)',
      dataIndex: 'require_weight',
      key: 'require_weight',
      render: (value) => <center>{formatComma(value)}</center>
    },
    {
      title: 'น้ำหนักส่งออก (kg)',
      dataIndex: 'delivery_weight',
      key: 'delivery_weight',
      render: (value) => <center>{formatComma(value)}</center>
    },
  ];

  const onChangeFilter = (value) => {
    setFilterSameProduct(value)
  };

  const ResetFilter = () => {
    setTableKey(tableKey => tableKey + 1)
  }

  React.useEffect(() => {
    ResetFilter();
  },[filterSameProduct])

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      setFilterSameProduct(true)
    }
  },[open])

  React.useEffect(() => {
    if(target){
        refreshData();
    }
  },[target])

  return(
    <div>
      <Modal
        open={open}
        onCancel={onClose}
        title={`ผูกรายการขาย [${_.get(target, 'lot_no' , '-')}]`}
        width={1000}
        okButtonProps={{
          style: { backgroundColor: colorSuccess}, loading
        }}
        okText={"ยืนยัน"}
        cancelText={"ปิด"}
        onOk={handleOK}
        footer={[]}
        destroyOnClose
      >
        <ErrorMessages message={errorMessages} style ={{ marginTop : 16}}/>
        <Row style={{ marginBottom : 20}}>
          <Col span={8}>
            <center>
              <Space style={{ fontWeight : 'bolder',}}>ใบแจ้งผลิต Lot No </Space>
              {`: ${_.get(target, 'lot_no', '')}`}
            </center>
          </Col>
          <Col span={8}>
            <center>
              <Space style={{ fontWeight : 'bolder',}}> สินค้า </Space>
              {`: ${_.get(target, 'product_name', '')}`}
            </center>
          </Col>
          <Col span={8}>
            <center>
              <Space style={{ fontWeight : 'bolder',}}> ปริมาณผลิต (Kg) </Space>
              {`: ${formatComma(_.get(target, 'require_weight', 0))}`}
            </center>
          </Col>
        </Row>
        <Divider>รายการขาย</Divider>
        รายการขาย : 
          <Select
            allowClear
            style={{width : 250, marginLeft : 10, marginBottom : 10}}
            placeholder="รายการขาย :"
            autoComplete="off"
            value={filterSameProduct}
            options={[
              {
                label : "สินค้าเดียวกัน",
                value : true
              },
              {
                label : "ทั้งหมด",
                value : false
              },
            ]}
            onChange={onChangeFilter}
          />
        <TSTable
          ref={tableRef}
          key={tableKey}
          columns={columns}
          size={'small'}
          url={type === PRODUCT_TYPE.CONCENTRATE_LATEX ? URL_SALE.SALE_ORDER : URL_SALE.SKIM_SALE_ORDER}
          params={{ product : filterSameProduct ? _.get(target, 'product') : '', is_load_completed : false }}
        />
        {/* <Form form={form} layout="vertical">
          <Form.Item 
            name={'sale_order'}
            label={'รายการขาย'}
            rules={[{ required: true, message: 'กรุณาหมายเลขล็อต!' }]}
          >
            <Select
              showSearch
              allowClear
              placeholder="รายการขาย"
              autoComplete="off"
              options={saleOrderDropdown.options}
              filterOption={false}
              onSearch={debounceSaleOrder}
              style={{ width : '100%'}}
            />
          </Form.Item>
        </Form> */}
      </Modal>
    </div>
  )
}
